// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/journey-log-schedule-i-entries.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/journey-log-schedule-i-entries/journey-log-schedule-i-entries.js';

mount([g0]);
